var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tags || []),function(tag,index){return _c('v-chip',{key:index,staticClass:"ma-1",attrs:{"small":"","color":tag.color}},[_vm._v(" "+_vm._s(tag.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }